export const rules = function () {
    return {
      cashRebate: [
        { required: true, message: '请输入费用政策', trigger: ['blur', 'change'] },
      ],
      cusRebate: [
        { required: true, message: '请选择审核结果', trigger: ['blur', 'change'] },
      ],
    }
}

export default {}